module.exports = __webpack_public_path__ + "pic6.6d8598c1e31cde466460.jpg";


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/assets/img/pic6.jpg
// module id = ../../../../../src/assets/img/pic6.jpg
// module chunks = main